import { sessaoFetch } from '@/service/fetch'

export async function get (registro) {
  return sessaoFetch(`consig`, `/entidades/buscarFGTS/${registro}`)
}



// WEBPACK FOOTER //
// ./src/api/fgts.js